module.exports = __webpack_public_path__ + "static/media/copy-icon.6ca3dd2d.svg";